import React from "react";
import { Star } from "lucide-react";
import { formatReviewDate, reviewStatusLabels } from "./reviewHelpers";
import "./Reviews.css";

export const ReviewRating = ({ rating }) => (
  <span className="review-rating" role="img" aria-label={`امتیاز ${rating} از ۵`}>
    {Array.from({ length: 5 }, (_, index) => (
      <Star key={index} size={17} aria-hidden="true" fill={index < rating ? "currentColor" : "none"} />
    ))}
    <span aria-hidden="true">{Number(rating).toLocaleString("fa-IR")} از ۵</span>
  </span>
);

const ReviewDetails = ({ review, showPatient = false }) => (
  <article className="review-details iran-sans" dir="rtl">
    <div className="review-row">
      <strong>{showPatient ? review.patientName : `نظر شما درباره دکتر ${review.doctorName || ""}`}</strong>
      <span className={`review-status review-status--${review.status}`}>
        {reviewStatusLabels[review.status] || "در انتظار تأیید"}
      </span>
    </div>
    {showPatient && <p className="review-muted">{review.sessionId ? "مشاوره با دکتر" : "نظر درباره دکتر"} {review.doctorName}</p>}
    <ReviewRating rating={review.rating} />
    <p className="review-content">{review.content}</p>
    <p className="review-muted review-meta">
     ثبت نظر:  <time dateTime={review.createdAt}>{formatReviewDate(review.createdAt, true)}</time>
      {review.moderatedAt && <span> · بررسی: {formatReviewDate(review.moderatedAt, true)}</span>}
    </p>
  </article>
);

export default ReviewDetails;
